import { BaseModalProps, Button } from "@animech/ui";
import { FunctionComponent, useMemo } from "react";
import { RestartIcon, useUiData } from "src/ui";
import { ModalBase } from "src/ui/components/modals/modal-base";

export type RestartModalProps = BaseModalProps & { onConfirm: () => void };

export const RestartModal: FunctionComponent<RestartModalProps> = ({
	onConfirm,
	...baseProps
}) => {
	const { localizer } = useUiData();
	const footerButtons = useMemo(
		() => [
			<Button key="restart" onClick={onConfirm}>
				{localizer.localizeTerm("resetModalOk")}
			</Button>,
		],
		[localizer, onConfirm],
	);

	return (
		<ModalBase
			icon={<RestartIcon />}
			footerButtons={footerButtons}
			{...baseProps}
			title={localizer.localizeTerm("resetModalTitle")}
		>
			<p>{localizer.localizeTerm("resetModalBody")}</p>
		</ModalBase>
	);
};
